// Mémorise la page demandée avant connexion (ex. lien /rapport/:token reçu sur WhatsApp)
// pour y revenir après le login.
const KEY = 'redirect_after_login';

export const saveRedirect = (path) => {
  if (!path || path === '/' || path.startsWith('/login')) return;
  try { sessionStorage.setItem(KEY, path); } catch { /* stockage indisponible */ }
};

export const consumeRedirect = () => {
  try {
    const path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    // Chemin interne uniquement (pas d'URL externe)
    return path && path.startsWith('/') && !path.startsWith('//') ? path : '/';
  } catch {
    return '/';
  }
};
